/**
 * `/$org/apps/imanage/search`: see IManageSearchPage.
 *
 * @module routes/$org.apps.imanage.search
 */
import { createFileRoute } from "@tanstack/react-router";

import { IManageSearchPage } from "../components/apps/imanage/IManagePages";
import { parseIManageSearch } from "../components/apps/imanage/imanagePaths";

function IManageSearchRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IManageSearchPage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace ?? false })}
    />
  );
}

export const Route = createFileRoute("/$org/apps/imanage/search")({
  validateSearch: parseIManageSearch,
  component: IManageSearchRoute,
});
